import React from 'react';
import DatePicker from 'react-datepicker';
import TimeInput from 'time-input';
import Select from 'react-select';
import {fromEvent} from 'rxjs/observable/fromEvent';
import {debounceTime} from 'rxjs/operators';

const moment = require('moment-timezone');

import BaseComponent from '../../../baseComponent.js';
import styles from './datetime-picker.scss';
import {defaultDateFormat, defaultDateTimeFormat} from '../../../../core/constants/defaultValues.js';

const getDatePickerOffset = (container) => {
  const pickerWidth = 300;
  const padding = 80;
  const parentElement = $(container).parents(".input-control");
  try {
    const offsetLeft = parentElement.offset().left;
    const diff = offsetLeft + padding + pickerWidth - window.innerWidth;
    if (diff > 0) {
      return `0 ${-diff}px`;
    } else {
      return null;
    }
  } catch (e) {
  }
};

const getPickerContainerStyle = (container, requiredWidth) => {
  const padding = 20;
  const containerElement = $(container);
  const parentElement = containerElement.parents(".input-control");
  let style = {
    position: "absolute",
    left: 0,
    right: "initial",
    top: "50px"
  };
  try {
    const offsetLeft = parentElement.offset().left;
    let space = window.innerWidth - offsetLeft - padding;
    if (space < requiredWidth) {
      style = {
        position: "absolute",
        left: "initial",
        right: 0,
        top: "50px"
      };
    }
    return style;
  } catch (e) {
  }
};

class DateTimePicker extends BaseComponent {
  constructor() {
    super();
    this.state = {};
  }

  open() {
    this.refs.picker.setOpen(true)
  }

  componentDidMount() {
    this.setContainerStyle();
    this.setPopoverTargetOffset();
    fromEvent(window, 'resize')
      .pipe(
        debounceTime(500),
      ).subscribe(_ => {
      this.setPopoverTargetOffset();
      this.setContainerStyle();
    });
  }

  setPopoverTargetOffset() {
    const offset = getDatePickerOffset(this.refs.container);
    this.setState({popoverTargetOffset: offset});
  }

  setContainerStyle() {
    const style = getPickerContainerStyle(this.refs.container, 570);
    if (style) {
      $(this.refs.container).css(style);
    }
  }

  render() {
    const dateTime = this.props.date || moment();
    const time = dateTime.format("HH:mm:ss:SSS");
    const props = {
      selected: dateTime,
      maxDate: moment(),
      dateFormat: this.props.format || defaultDateTimeFormat,
      onChange: date => {
        this.props.onDateChange(date);
        this.props.onBlur();
      },
      onClickOutside: this.props.onBlur,
      popoverTargetOffset: this.state.popoverTargetOffset || "0 0"
    };

    return (
      <div className={styles.timePicker} ref="container">
        <div>
          <i className="material-icons">date_range</i>
          <DatePicker ref="picker"
                      {...props}/>
        </div>
        <div>
          <i className="material-icons">access_time</i>
          <TimeInput value={time} onChange={time => this.props.onDateChange(null, time, null)}/>
        </div>
        <div>
          <TimezoneSelect timezone={this.props.timezone}
                          onTimezoneChange={tz => this.props.onDateChange(null, null, tz)}/>
        </div>
      </div>
    );
  }
}

class TimePicker extends BaseComponent {
  componentDidMount() {
    this.setContainerStyle();
    fromEvent(window, 'resize')
      .pipe(
        debounceTime(500),
      ).subscribe(_ => {
      this.setContainerStyle();
    });
  }

  setContainerStyle() {
    const style = getPickerContainerStyle(this.refs.container, 425);
    if (style) {
      $(this.refs.container).css(style);
    }
  }

  render() {
    const dateTime = this.props.date || moment();
    const time = dateTime.format("HH:mm:ss:SSS");
    return (
      <div className={styles.timePicker} ref="container">
        <div>
          <i className="material-icons">access_time</i>
          <TimeInput value={time} onChange={time => this.props.onTimeChange(null, time, null)}/>
        </div>
        <TimezoneSelect timezone={this.props.timezone}
                        onTimezoneChange={tz => this.props.onTimeChange(null, null, tz)}/>
      </div>
    );
  }
}

class DateOnlyPicker extends BaseComponent {
  constructor() {
    super();
    this.state = {};
  }

  open() {
    this.refs.picker.setOpen(true);
  }

  componentDidMount() {
    this.setPopoverTargetOffset();
    this.setContainerStyle();
    fromEvent(window, 'resize')
      .pipe(
        debounceTime(500),
      ).subscribe(_ => {
      this.setPopoverTargetOffset();
      this.setContainerStyle();
    });
  }

  setContainerStyle() {
    const style = getPickerContainerStyle(this.refs.container, 190);
    if (style) {
      $(this.refs.container).css(style);
    }
  }

  setPopoverTargetOffset() {
    const offset = getDatePickerOffset(this.refs.container);
    this.setState({popoverTargetOffset: offset});
  }

  render() {
    const props = {
      selected: this.props.date || moment(),
      maxDate: moment(),
      dateFormat: this.props.format || defaultDateFormat,
      onChange: date => {
        this.props.onDateChange(date);
        if (this.props.onBlur) {
          this.props.onBlur();
        }
      },
      onClickOutside: this.props.onBlur,
      popoverTargetOffset: this.state.popoverTargetOffset || "0 0"
    };
    return (
      <div className={styles.dateOnlyPicker} ref="container">
        <i className="material-icons">date_range</i>
        <DatePicker
          ref="picker"
          {...props} />
      </div>
    );
  }
}

class TimezoneSelect extends BaseComponent {
  render() {
    const timezoneOptions = moment.tz.names().map(tz => {
      return {value: tz, label: tz}
    });
    return (
      <Select
        name="timezone"
        placeholder="Select timezone"
        value={this.props.timezone}
        options={timezoneOptions}
        onChange={(option) => this.props.onTimezoneChange(option.value)}
      />
    );
  }
}

export {TimePicker, DateOnlyPicker, DateTimePicker};


// WEBPACK FOOTER //
// ./src/components/dashboard/control-widget/selection-contorl/dateTimePicker.jsx